import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import RateCardDto from '@/models/RateCards/RateCardDto';
import PositionDto from '@/models/Positions/PositionDto';

export default class RateCardPositionDto extends BaseAgencyScopeEntityDto {
    rateCardId: string;
    rateCard: RateCardDto = new RateCardDto();
    positionId: string;
    position: PositionDto = new PositionDto();
    chargeRate: number;
}